module.exports = __webpack_public_path__ + "img/circle-success.5e9399ca.svg";